import { render, staticRenderFns } from "./pageNavigation.vue?vue&type=template&id=79a2ed7a&"
import script from "./pageNavigation.vue?vue&type=script&lang=js&"
export * from "./pageNavigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\CA5\\PhpstormProjects\\te-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('79a2ed7a', component.options)
    } else {
      api.reload('79a2ed7a', component.options)
    }
    module.hot.accept("./pageNavigation.vue?vue&type=template&id=79a2ed7a&", function () {
      api.rerender('79a2ed7a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/Pages/page-part/pageNavigation.vue"
export default component.exports